import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Divider,
  AppBar,
  Toolbar,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import apiService from "../components/ReasuableFuncations/api";

const OptionButton = styled(Button)(({ theme, selected }) => ({
  flex: 1,
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  backgroundColor: selected
    ? theme.palette.primary.main
    : theme.palette.grey[300],
  color: selected ? theme.palette.common.white : theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const countryCodes = [
  { code: "+1", country: "United States" },
  { code: "+1", country: "Canada" },
  { code: "+44", country: "United Kingdom" },
  { code: "+61", country: "Australia" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" },
  { code: "+91", country: "India" },
  { code: "+34", country: "Spain" },
  { code: "+41", country: "Switzerland" },
  { code: "+46", country: "Sweden" },
  { code: "+31", country: "Netherlands" },
  { code: "+55", country: "Brazil" },
  { code: "+61", country: "New Zealand" },
  { code: "+65", country: "Singapore" },
  { code: "+66", country: "Thailand" },
  { code: "+7", country: "Russia" },
  { code: "+60", country: "Malaysia" },
  { code: "+52", country: "Mexico" },
  { code: "+63", country: "Philippines" },
  { code: "+27", country: "South Africa" },

  // Additional African countries
  { code: "+213", country: "Algeria" },
  { code: "+244", country: "Angola" },
  { code: "+229", country: "Benin" },
  { code: "+267", country: "Botswana" },
  { code: "+226", country: "Burkina Faso" },
  { code: "+257", country: "Burundi" },
  { code: "+237", country: "Cameroon" },
  { code: "+238", country: "Cape Verde" },
  { code: "+236", country: "Central African Republic" },
  { code: "+235", country: "Chad" },
  { code: "+269", country: "Comoros" },
  { code: "+243", country: "Democratic Republic of the Congo" },
  { code: "+242", country: "Republic of the Congo" },
  { code: "+225", country: "Côte d'Ivoire" },
  { code: "+253", country: "Djibouti" },
  { code: "+20", country: "Egypt" },
  { code: "+240", country: "Equatorial Guinea" },
  { code: "+291", country: "Eritrea" },
  { code: "+251", country: "Ethiopia" },
  { code: "+241", country: "Gabon" },
  { code: "+220", country: "Gambia" },
  { code: "+233", country: "Ghana" },
  { code: "+224", country: "Guinea" },
  { code: "+245", country: "Guinea-Bissau" },
  { code: "+254", country: "Kenya" },
  { code: "+266", country: "Lesotho" },
  { code: "+231", country: "Liberia" },
  { code: "+218", country: "Libya" },
  { code: "+261", country: "Madagascar" },
  { code: "+265", country: "Malawi" },
  { code: "+223", country: "Mali" },
  { code: "+222", country: "Mauritania" },
  { code: "+230", country: "Mauritius" },
  { code: "+212", country: "Morocco" },
  { code: "+258", country: "Mozambique" },
  { code: "+264", country: "Namibia" },
  { code: "+227", country: "Niger" },
  { code: "+234", country: "Nigeria" },
  { code: "+250", country: "Rwanda" },
  { code: "+290", country: "Saint Helena" },
  { code: "+248", country: "Seychelles" },
  { code: "+232", country: "Sierra Leone" },
  { code: "+252", country: "Somalia" },
  { code: "+211", country: "South Sudan" },
  { code: "+249", country: "Sudan" },
  { code: "+268", country: "Eswatini" },
  { code: "+255", country: "Tanzania" },
  { code: "+228", country: "Togo" },
  { code: "+216", country: "Tunisia" },
  { code: "+256", country: "Uganda" },
  { code: "+260", country: "Zambia" },
  { code: "+263", country: "Zimbabwe" },
];

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  "& > :not(style) ~ :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+27");
  const [password, setPassword] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [regionalNetworkOption, setRegionalNetworkOption] = useState("");
  const [memberStateOption, setMemberStateOption] = useState("");
  const [countryOption, setCountryOption] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [supportDialogOpen, setSupportDialogOpen] = useState(false);
  const [isRegistered, setIsRegistered] = useState(
    localStorage.getItem("isRegistered") === "true"
  );
  const [loading, setLoading] = useState(false);

  const regionStates = {
    COMESA: [
      "Burundi",
      "Comoros",
      "Democratic Republic of the Congo (DRC)",
      "Djibouti",
      "Egypt",
      "Eritrea",
      "Burundi",
      "Eswatini",
      "Ethiopia",
      "Kenya",
      "Libya",
      "Madagascar",
      "Malawi",
      "Mauritius",
      "Rwanda",
      "Seychelles",
      "Somalia",
      "South Sudan",
      "Sudan",  
      "Zambia",
      "Zimbabwe",
      "Tanzania",
    ],
    EAC: ["Burundi", "Kenya", "Rwanda", "South Sudan", "Tanzania", "Uganda","Congo","Somalia"],
    IGAD: [
      "Djibouti",
      "Eritrea",
      "Ethiopia",
      "Kenya",
      "Somalia",
      "South Sudan",
      "Sudan",
      "Uganda",
    ],
    IOC: [
      "Comoros",
      "France (Réunion)",
      "Madagascar",
      "Mauritius",
      "Seychelles",
    ],
    SADC: [
      "Angola",
      "Botswana",
      "Comoros",
      "Democratic Republic of the Congo (DRC)",
      "Eswatini",
      "Lesotho",
      "Madagascar",
      "Malawi",
      "Mozambique",
      "Namibia",
      "Seychelles",
      "South Africa",
      "Tanzania",
      "Zambia",
      "Zimbabwe",
      "Tanzania",
    ],
  };

  const [availableStates, setAvailableStates] = useState([]);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // 'success' or 'error'

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      const response = await apiService.post("/api/register", {
        username,
        email,
        phoneNumber: `${countryCode}${phoneNumber}`,
        password,
        selectedOption,
        regionalNetworkOption:
          selectedOption === "Regional Network" ? regionalNetworkOption : null,
        memberStateOption:
          selectedOption === "Member State" ? memberStateOption : null,
        countryOption: selectedOption === "Member State" ? countryOption : null,
      });

      const data = response.data;
      if (response.statusText === "Created") {
        setSuccess("Registration successful! You can now log in.");
        setSnackbarSeverity("success");
        setSnackbarMessage("Registration successful! You can now log in.");
        setIsRegistered(true);
        setSnackbarOpen(true);
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        setError(data.message || "Registration failed. Please try again.");
        setSnackbarSeverity("error");
        setSnackbarMessage(
          data.message || "Registration failed. Please try again."
        );
        setSnackbarOpen(true);
      }
    } catch (err) {
      setError("Registration failed. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarMessage("Registration failed. Please try again.");
      setSnackbarOpen(true);
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (selectedOption === "Member State" && memberStateOption) {
      setAvailableStates(regionStates[memberStateOption] || []);
    } else {
      setAvailableStates([]);
    }

    return () => {
      localStorage.removeItem("isRegistered");
    };
  }, [memberStateOption, selectedOption]);

  const handleSupportDialogOpen = () => {
    setSupportDialogOpen(true);
  };

  const handleSupportDialogClose = () => {
    setSupportDialogOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundImage: "url(./background.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <AppBar
        position="static"
        sx={{ backgroundColor: "transparent", boxShadow: "none" }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box display="flex" alignItems="center">
            <img
              src="./l2.png"
              alt="COMESA Logo"
              style={{ maxWidth: "50px", marginRight: "16px" }}
            />
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Portal
            </Typography>
          </Box>

          <Box>
            <Button color="inherit" component={Link} to="/about">
              About
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Container
        maxWidth="md"
        sx={{
          marginBottom: "0px",
          paddingRight: "24px",
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflowY: "auto",
        }}
      >
        <Paper
          elevation={20}
          sx={{
            marginBottom: "5rem",
            p: 4,
            bgcolor: "rgba(255, 255, 255)",
            width: "80%",
            maxWidth: "800px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              component="h1"
              variant="h5"
              sx={{ my: 2, fontWeight: "bold" }}
            >
              Register
            </Typography>

            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1, width: "100%" }}
            >
              {/* {error && <Alert severity="error">{error}</Alert>}
              {success && <Alert severity="success">{success}</Alert>} */}

              <TextField
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <FormControl
                fullWidth
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  my: 2,
                }}
              >
                <FormControl sx={{ minWidth: 120, mr: 2 }}>
                  <InputLabel>Country Code</InputLabel>
                  <Select
                    value={countryCode}
                    onChange={(e) => setCountryCode(e.target.value)}
                    label="Country Code"
                  >
                    {countryCodes.map((code) => (
                      <MenuItem key={code.code} value={code.code}>
                        {code.code} ({code.country})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  required
                  fullWidth
                  id="phone"
                  label="Phone Number"
                  name="phone"
                  autoComplete="phone"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </FormControl>

              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="new-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <OptionButton
                  selected={selectedOption === "Comesa"}
                  onClick={() => setSelectedOption("Comesa")}
                  sx={{ my: 2, fontSize: "10px" }}
                >
                  ADMIN
                </OptionButton>
                <OptionButton
                  selected={selectedOption === "Regional Network"}
                  onClick={() => setSelectedOption("Regional Network")}
                  sx={{ my: 2, fontSize: "10px" }}
                >
                  Regional Network
                </OptionButton>
                <OptionButton
                  selected={selectedOption === "Member State"}
                  onClick={() => setSelectedOption("Member State")}
                  sx={{ my: 2, fontSize: "10px" }}
                >
                  Member State
                </OptionButton>
              </Box>

              {selectedOption === "Regional Network" && (
                <FormControl fullWidth>
                  <InputLabel>Region</InputLabel>
                  <Select
                    value={regionalNetworkOption}
                    onChange={(e) => setRegionalNetworkOption(e.target.value)}
                    label="Region"
                  >
                    <MenuItem value="COMESA">COMESA</MenuItem>
                    <MenuItem value="EAC">EAC</MenuItem>
                    <MenuItem value="IGAD">IGAD</MenuItem>
                    <MenuItem value="IOC">IOC</MenuItem>
                    <MenuItem value="SADC">SADC</MenuItem>
                  </Select>
                </FormControl>
              )}

              {selectedOption === "Member State" && (
                <>
                  <FormControl fullWidth sx={{ my: 2 }}>
                    <InputLabel>Region</InputLabel>
                    <Select
                      value={memberStateOption}
                      onChange={(e) => setMemberStateOption(e.target.value)}
                      label="Region"
                    >
                      <MenuItem value="COMESA">COMESA</MenuItem>
                      <MenuItem value="EAC">EAC</MenuItem>
                      <MenuItem value="IGAD">IGAD</MenuItem>
                      <MenuItem value="IOC">IOC</MenuItem>
                      <MenuItem value="SADC">SADC</MenuItem>
                    </Select>
                  </FormControl>

                  {memberStateOption && (
                    <FormControl fullWidth sx={{ my: 2 }}>
                      <InputLabel>Member State</InputLabel>
                      <Select
                        value={countryOption}
                        onChange={(e) => setCountryOption(e.target.value)}
                        label="Member State"
                      >
                        {availableStates.map((state) => (
                          <MenuItem key={state} value={state}>
                            {state}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                </>
              )}

              <Divider sx={{ my: 2 }} />

              {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CircularProgress />
                </Box>
              ) : (
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                >
                  Register
                </Button>
              )}

              <Grid
                container
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Grid
                  item
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  Already have an account?_
                  <Link to="/login">Log in</Link>
                </Grid>
                <Grid item sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <Link onClick={handleSupportDialogOpen}>
                    Trouble shooting issues
                  </Link>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Paper>
      </Container>

      {/* Support Dialog */}
      <Dialog open={supportDialogOpen} onClose={handleSupportDialogClose}>
        <DialogTitle>Contact Support</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            If you're experiencing issues, please reach out to our support team:
          </Typography>
          <Typography variant="body2" sx={{ mt: 1 }}>
            Email: support@company.com
            <br />
            Phone: +123 456 7890
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button onClick={handleSupportDialogClose}>Close</Button>
          </Box>
        </DialogContent>
      </Dialog>

      <Box component="footer" sx={{ bgcolor: "#282c34", py: 2 }}>
        <Typography variant="body2" align="center" color="white">
          &copy; {new Date().getFullYear()} EA-SA-IO Portal. All rights reserved.
        </Typography>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Register;
